export default __webpack_public_path__ + "static/media/serviceRequest.d6daf47f.svg";